import { Outlet } from 'react-router';

import { Sidebar } from './Sidebar';
import { TestModeBanner } from './TestModeBanner';
import { Topbar } from './Topbar';

/**
 * Dashboard chrome — the layout route element for `/app/*`. A
 * full-height row: fixed left `Sidebar` + a main column of
 * `TestModeBanner` (non-prod only) → `Topbar` → scrollable content
 * (`<Outlet />`). Stripe-style: quiet borders, neutral surfaces.
 */
export function AppShell() {
  return (
    <div className="bg-muted/20 flex h-screen w-full overflow-hidden">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TestModeBanner />
        <Topbar />
        <main className="flex-1 overflow-y-auto px-8 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
